import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, Check } from "lucide-react";
import { LOGO_URL } from "../lib/brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSubmitted(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 relative overflow-hidden">
      <div className="absolute -top-24 -left-16 w-72 h-72 rounded-full bg-[#d9d4f1] opacity-70 blur-2xl" />
      <div className="absolute -bottom-24 -right-16 w-80 h-80 rounded-full bg-[#b5e4ca] opacity-60 blur-2xl" />
      <div className="relative w-full max-w-md">
        <div className="mb-6 text-center">
          <img
            src={LOGO_URL}
            alt="SyncBook"
            className="mx-auto w-full max-w-[240px] rounded-2xl border-2 border-[#1a1a1a] shadow-[4px_4px_0_0_#1a1a1a] mb-4"
          />
          <h1 className="font-display text-4xl font-black tracking-tight">
            {submitted ? "Check your inbox" : "Reset password"}
          </h1>
          <p className="text-sm text-[#4a4a4a] mt-2 font-medium">
            {submitted
              ? "If that email is registered, we sent you a reset link."
              : "Enter your email and we'll send you a reset link."}
          </p>
        </div>

        {!submitted ? (
          <form onSubmit={submit} className="nb-card-lg p-6 space-y-4" data-testid="forgot-password-form">
            <div>
              <label className="label">Email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="nb-input"
                placeholder="you@example.com"
              />
            </div>
            <button
              data-testid="send-reset-btn"
              disabled={busy}
              type="submit"
              className="nb-btn nb-btn-dark w-full !py-3"
            >
              <Mail size={18} strokeWidth={3} /> {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link
              to="/login"
              data-testid="back-to-login"
              className="nb-btn nb-btn-secondary w-full !py-2 justify-center"
            >
              <ArrowLeft size={14} strokeWidth={3} /> Back to sign in
            </Link>
          </form>
        ) : (
          <div className="nb-card-lg p-6 space-y-4 text-center" data-testid="forgot-password-sent">
            <div
              className="w-16 h-16 mx-auto rounded-full border-2 border-[#1a1a1a] flex items-center justify-center"
              style={{ background: "#b5e4ca" }}
            >
              <Check size={32} strokeWidth={3} />
            </div>
            <div className="text-sm font-medium text-[#4a4a4a]">
              Sent to <span className="font-black text-[#1a1a1a]">{email}</span>.<br />
              The link expires in <b>30 minutes</b>. Check your spam if it&apos;s not in your inbox.
            </div>
            <Link
              to="/login"
              data-testid="back-to-login"
              className="nb-btn nb-btn-dark w-full !py-3 justify-center"
            >
              Back to sign in
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
